import { Fragment, type ReactNode } from 'react';
import { transcriptGroups, type Segment } from '@jabberr/core';

/** Display coherent speech while retaining original raw indices for actions. */
export function TranscriptGroups<T extends Segment>({ segments, children }: {
  segments: readonly T[];
  children: (segment: T, firstIndex: number, lastIndex: number) => ReactNode;
}) {
  return transcriptGroups(segments).map(({ segment, firstIndex, lastIndex }) => (
    <Fragment key={firstIndex}>{children(segment, firstIndex, lastIndex)}</Fragment>
  ));
}
